import { buildWabunkaGuestsNumberOptions, type Options } from '@/models/option';
import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import type { WabunkaReservationFormStep1 } from '@/wabunka-src/features/Experience';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

interface UseParticipantsProps {
  experience: WabunkaExperienceViewModel;
  experienceEvent: WabunkaExperienceEventViewModel;
  reservationStep1Form: WabunkaReservationFormStep1;
}

/**
 * 参加人数選択肢管理用Composable
 */
export const useParticipants = ({ experience, experienceEvent, reservationStep1Form }: UseParticipantsProps) => {
  // 参加人数の選択肢
  const defaultParticipants = ref<number>(reservationStep1Form.numOfParticipants);

  // 参加人数の選択肢の初期値
  const participantsOptions = computed<Options>(() => {
    const minGuestsPerReservation = experienceEvent.id !== '' ? experienceEvent.minGuestsPerReservation : experience.minGuestsPerReservation;
    const maxGuests = experienceEvent.id !== '' ? experienceEvent.maxGuests : experience.maxGuests;
    return buildWabunkaGuestsNumberOptions(minGuestsPerReservation, maxGuests);
  });

  watch(
    participantsOptions,
    () => {
      if (participantsOptions.value.length === 0) {
        return;
      }
      // 体験イベントが選択されている場合は自動選択しない(予約導線から戻ってきた時)
      if (experienceEvent.id !== '') {
        return;
      }
      // 選択肢が存在するとき、選択肢の1番目を初期値に設定する
      defaultParticipants.value = participantsOptions.value[0].value as number;
    },
    { immediate: true },
  );

  watch(
    () => reservationStep1Form.experienceEventId,
    (newValue, oldValue) => {
      if (newValue !== oldValue) {
        // 選択肢にdefault valueが入っているとv-modelに反映してしまうので、ここで初期値を設定する
        // TODO: 影響範囲を見てデフォルト値の挙動を直すor認識合わせする
        defaultParticipants.value = reservationStep1Form.numOfParticipants;
      }
    },
  );

  return {
    defaultParticipants,
    participantsOptions,
  };
};
